import './style.scss'

import Title from 'components/Title'
import LinkGroup from 'components/LinkGroup'

export default {
  name: 'DownloadsList',
  props: ['componentData'],
  computed: {
    downloadsListData () {
      return this.componentData.map(x => {
        x.download_links.map(y => {
          y['external_link'] = !y.is_internal_link
          y['external_link_url'] = y.file_link ? y.file_link : null
          y['internal_link'] = y.is_internal_link ? y.internal_link : null
          y.title = y.title
          return y
        })
        return x
      })
    }
  },
  render (h) {
    const { downloadsListData } = this
    return (
      <ul class='DownloadsList'>
        {downloadsListData && downloadsListData.length
          ? (downloadsListData.map(i => (
            <li class='DownloadsList__item'>
              <Title class='DownloadsList__item-title' id={i.title} level={2}>{i.title}</Title>
              <LinkGroup class='DownloadsList__links' componentData={i.download_links} />
            </li>
          )))
        : null}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/DownloadsList/index.js